export default __webpack_public_path__ + "static/media/6.8.bb056301.mp3";